import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import randomstring from 'uuid/v4';

class PresentationDialog extends React.Component {
    state = {
        value: undefined,
        open: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.value !== state.value) {
            state.value = props.value;
            return state;
        }
        return null;
    }

    handleChange = (event) => {
        const { value } = this.state;
        value[event.target.name] = event.target.value;
        this.setState({ value: value });
    };

    handleClose = (value) => (event) => {
        this.props.onClose(value);
    };

    render() {
        const { value } = this.state;
        const { intl, types } = this.props;
        console.log(value);
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple" className="upper">
                                {intl.formatMessage({ id: 'type_label_type' })}
                            </InputLabel>
                            <Select
                                native
                                value={value.tipo}
                                onChange={this.handleChange}
                                inputProps={{ name: 'tipo', id: 'tipo' }}
                                className="upper"
                            >
                                <option key={randomstring()} value={undefined} />
                                {types &&
                                    types
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option
                                                    key={randomstring()}
                                                    className="upper"
                                                    value={cat.id}
                                                >
                                                    {cat.nombre}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            id={'valor'}
                            name={'valor'}
                            label={intl.formatMessage({ id: 'type_label_value' })}
                            className={'flex_full_row'}
                            value={value.valor}
                            onChange={this.handleChange}
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            id={'comentario'}
                            name={'comentario'}
                            label={intl.formatMessage({ id: 'type_label_comment' })}
                            className={'flex_full_row'}
                            value={value.comentario}
                            onChange={this.handleChange}
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button disabled={!value.tipo || !value.valor} onClick={this.handleClose(value)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PresentationDialog;



// WEBPACK FOOTER //
// ./src/components/complex/manage/provider/DialogContacts.js